function none() {}

export default function (selector) {
  return selector == null ? none : function () {
    return this.querySelector(selector);
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-selection@1.4.1@d3-selection/src/selector.js
// module id = 383
// module chunks = 0